import { baseConfig } from '../base.config';
import { mix } from '@oec-seller/sdk/m4b-seller-material';
export const REGION_CONFIG = mix(baseConfig, {
  features: {
    showRegionItem: true,
    defaultRegion: 'BR',
    privacyPolicyLink: 'https://seller-br.tiktok.com/university/essay?knowledge_id=3268441302615809&identity=1'
  },
  language: {
    switchLang: ['en', 'pt-BR', 'zh-CN'],
    defaultLang: 'pt-BR'
  }
} as Partial<typeof baseConfig>);
